import styled from 'styled-components';

const petCreateStyledComponent = styled.div``;

export default petCreateStyledComponent;
